import React, { useState } from "react";
import { DashboardNotificationSection } from "../MainDashboard/DashboardNotificationSection";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import swal from "sweetalert";
import { Select, Radio } from "antd";
import "./Feedback.css";
import ModalVideo from "../ModuleVideos/ModalVideo";
const { Option } = Select;

export const Feedback = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const categories = [
    "Bug Report",
    "Feature Request",
    "Usability Suggestion",
    "General Comment",
    "Question",
    "Other",
  ];
  const severity = ["Critical", "High", "Medium", "Low"];
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const handlechange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit...", formData);
    try {
      setLoading(true);
      const response = await DEATH_API.sendFeedback(formData);
      console.log("response", response);
      if (response.status === 200) {
        swal("Success", response.message, "success");
      }
      if (response.status === 400) {
        swal("Oops!", response.message, "error");
      }
      setLoading(false);
      setFormData(null);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
    setFormData(null);
  };

  return (
    <div style={{ display: "flex" }}>
    <ModalVideo module="Feedback" autoOpen={true} />
      <div
        className="MainDashboard1"
        style={{
          background: "white",
          borderRadius: "8px",
          margin: "1rem",
          width: "100%",
          padding: "2rem",
        }}
      >
        <div className="feedback-MainHeading">
          Your Insights Drive Our Future!
        </div>
        <div
          className="feedback-SubMainHeading"
          style={{ margin: "0rem 0rem 1rem 0rem" }}
        >
          We're building Asset Planet for professionals like you. Your feedback
          is crucial to our evolution.
          <br /> Interested in helping shape our roadmap and being featured on
          our website?{" "}
          <a
            style={{ color: "#2a3da3" }}
            href="https://assetplanet.com/advisory/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click HERE
          </a>{" "}
        </div>
        <div className="feedback-MainHeading">Send us Your Feedback</div>
        <div className="feedback-SubMainHeading">
          Your feedback can be anonymous. Only include your name and email if
          you'd like a direct response.
        </div>
        {/* <div style={{ marginTop: "1rem" }}>
          This feedback form goes directly to{" "}
          <a style={{ color: "#2a3da3" }} href="mailto:support@assetplanet.com">
            support@assetplanet.com
          </a>{" "}
          and you can contact us there if you have other questions or concerns.
        </div> */}
        <form onSubmit={handleSubmit}>
          <div style={{ width: "50%", minWidth: "30rem", marginTop: "1rem" }}>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">
                Category <span style={{ color: "red" }}>*</span>
              </div>
              <Select
                showSearch
                placeholder="-Select-"
                value={formData ? formData.category : ""}
                size={"large"}
                style={{ marginBottom: "10px" }}
                onChange={(value) => handlechange("category", value)}
              >
                {categories.map((category, index) => (
                  <Option key={index} value={category}>
                    {category}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">
                Which Module/Feature does this relate to?
              </div>
              <input
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="e.g., Planner > Goal Funding, Organizer > Documents, General UI etc."
                type="text"
                value={formData ? formData.module : ""}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="module"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">Name</div>
              <input
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Enter Your Name (Optional)"
                type="text"
                value={formData ? formData.name : ""}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="name"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">Email</div>
              <input
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Enter Your Email (Optional)"
                type="email"
                value={formData ? formData.email : ""}
                onChange={(e) => {
                  e.preventDefault();
                  e.persist();
                  if (!isValidEmail(e.target.value)) {
                    if (e.target.value === "") {
                      setError(null);
                    } else {
                      setError("Email is invalid");
                    }
                  } else {
                    setError(null);
                  }
                  handlechange(e.target.name, e.target.value);
                }}
                name="email"
              />
              {error && (
                <span style={{ color: "red", fontSize: "12px" }}>{error}</span>
              )}
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">
                Severity (if Bug Report Selected)
              </div>
              <Radio.Group
                onChange={(e) => handlechange("severity", e.target.value)}
                value={formData ? formData.severity : ""}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {severity.map((level, index) => (
                  <Radio value={level} key={index}>
                    {level}
                  </Radio>
                ))}
              </Radio.Group>
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">
                Feedback<span style={{ color: "red" }}>*</span>
              </div>
              <textarea
                className="inputFieldClass"
                style={{ width: "100%", resize: "none" }}
                placeholder={
                  "Describe your feedback, suggestions, or issues here.\nPlease be as detailed as possible, including steps to reproduce bugs or your desired outcome for features."
                }
                rows={5}
                value={formData ? formData.feedback : ""}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="feedback"
              />
            </div>
            <button
              className="feedbackButton"
              type="submit"
              disabled={
                formData && formData.feedback && formData.category
                  ? false
                  : true
              }
              style={{
                opacity:
                  formData && formData.feedback && formData.category
                    ? "1"
                    : "0.5",
                cursor:
                  formData && formData.feedback && formData.category
                    ? "pointer"
                    : "not-allowed",
              }}
              // onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      {/* <div className="notificationMain">
        <DashboardNotificationSection />
        </div> */}
      <Loader isLoading={loading} />
    </div>
  );
};
